var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8302_42009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.1607V17.6607H9V7.03698C9 6.67398 9.2595 6.36348 9.61575 6.29898L16.7198 5.00748C16.9643 4.96248 17.1982 5.12523 17.2425 5.36973C17.2478 5.39598 17.25 5.42223 17.25 5.44998V6.40998L20.25 6.41073C20.664 6.41073 21 6.74673 21 7.16073V17.6607H22.5V19.1607H19.5V7.91073H17.25V19.1607H7.5ZM15.75 6.70773L10.5 7.66323V17.6607H15.75V6.70773ZM15 11.6607V13.1607H13.5V11.6607H15Z",
    fill: "#15151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.47474 12.2388C4.2794 12.4341 4.2794 12.7507 4.47474 12.946L5.8892 14.36C6.08447 14.5552 6.08455 14.8717 5.88938 15.067L5.5358 15.4209C5.34056 15.6162 5.02388 15.6163 4.82857 15.421L2.35355 12.946C2.15829 12.7507 2.15829 12.4341 2.35355 12.2389L4.82857 9.76383C5.02388 9.56852 5.34056 9.56858 5.5358 9.76396L5.88938 10.1178C6.08455 10.3131 6.08447 10.6296 5.8892 10.8248L4.47474 12.2388Z",
    fill: "#15151A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8302_42009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.0d727448df2705b5f1fa90a35e5f064c.svg";
export { ForwardRef as ReactComponent };